module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHAQMAAAD+nMWQAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAABJJREFUeJxj+MdQw2DBIMAABgAUsAHD3c3BpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/menu-expanded.png
// module id = 219
// module chunks = 0